module.exports = __webpack_public_path__ + "img/03-2-1缩短报表时间.bee24071.svg";